var _g;
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ConfirmationIcon(_ref) {
  let {
    width = 20
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: width,
    strokeWidth: "5.5",
    strokeLinecap: "round",
    stroke: "currentColor",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    children: _g || (_g = /*#__PURE__*/_jsxs("g", {
      fill: "none",
      strokeWidth: "6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M30.9,5.9C16.8,5.9,5.4,17.4,5.4,31.5s11.4,25.6,25.5,25.6s25.5-11.5,25.5-25.6S45,5.9,30.9,5.9z"
      }), /*#__PURE__*/_jsx("polyline", {
        points: "16.6,26.1 30.5,40 59.8,10.7 "
      })]
    }))
  });
}
export default ConfirmationIcon;